document.addEventListener('DOMContentLoaded', function() {
    var editionsCalEl = document.getElementById('ee-editions-calendar');
    var editions = JSON.parse(editionsCalEl.dataset.editions);
    var editionDates = Object.keys(editions);
    var curEditionDate = editionsCalEl.dataset.editionDate;
    var { Calendar } = window.VanillaCalendarPro;

    var editionsCal = new Calendar('#ee-editions-calendar', {
        firstWeekday: 0,
        disableAllDates: true,
        enableDates: editionDates,
        selectedWeekends: [],
        selectedTheme: 'bd-ee',
        dateToday: new Date(curEditionDate),
        onClickDate: function(self) {
            if (editionDates.includes(self.context.selectedDates[0])) {
                window.location = editions[self.context.selectedDates[0]];
            }
        }
    });
    editionsCal.init();
});